import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY } from "../../../api/queryKeys";
import { QueryAdminCompanySettingsResponse } from "../../../types";

export const getCompanySettingsData = () =>
  api
    .get<QueryAdminCompanySettingsResponse>(
      QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY
    )
    .then((res) => res.data);

export default function useGetCompanySettings() {
  return useQuery(
    [QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY],
    getCompanySettingsData
  );
}
